import _ from 'lodash'

import {
  FETCHING_TREENODES,
  FETCHED_TREENODES,
  FETCHING_USER_TREENODES,
  FETCHED_USER_TREENODES,
} from '_reducers/treeNodes'
import { MydAPI } from '_services/default'


export const getFullName = _.memoize(
  (treeNode, treeNodes, join='/', isRoot=true) => {

    let parent = _.find(treeNodes, {id: treeNode.parentId}),
        ret = []

    if (parent) {
      ret = getFullName(parent, treeNodes, join, false)
    }

    if (isRoot === false)
      return [
        ...ret,
        treeNode.name,
      ]

    return [
      ...ret,
      treeNode.name,
    ].join(join)
  },
  (treeNode) => {
    return treeNode.id
  }
)


function _fetchingTreeNodes() {
  return {
    type: FETCHING_TREENODES,
  }
}

function _fetchedTreeNodes(treeNodes) {
  return {
    type: FETCHED_TREENODES,
    treeNodes,
  }
}

function _fetchingUserTreeNodes() {
  return {
    type: FETCHING_USER_TREENODES,
  }
}

function _fetchedUserTreeNodes(treeNodes) {
  return {
    type: FETCHED_USER_TREENODES,
    treeNodes,
  }
}

export const fetchTreeNodes = _.memoize(
  (filters=[]) => {
    return dispatch => new Promise((resolve, reject) => {

      filters = _.isEmpty(filters) ? '' : `&filter=${filters}`
      
      dispatch(_fetchingTreeNodes())

      MydAPI.get(`/treenodes?page[size]=0${filters}`).then(treeNodes => {
        let retTreeNodes = _.map(treeNodes.data.data, treeNode => {
          return {
            id: treeNode.id,
            ...treeNode.attributes,
          }
        })

        dispatch(_fetchedTreeNodes(retTreeNodes))
        resolve(retTreeNodes)

      }).catch(err => {
        reject(err)
      })
    })
  },
  (a) => {
    return JSON.stringify(a)
  }
)

export const getParentTreeNode = _.memoize(
  (treeNode, included) => {
    let hasAttributes = _.has(treeNode, 'attributes'),
        nTreeNode = treeNode

    if (hasAttributes) {
      nTreeNode = {
        id: treeNode.id,
        ...treeNode.attributes,
      }
    }

    if (nTreeNode.parentId === 0) {
      return [nTreeNode]
    }

    let parent = _.find(included, {id: nTreeNode.parentId}),
        parents = getParentTreeNode(parent, included)

    return [
      ...parents,
      nTreeNode,
    ]
  },
  (a) => {
    return a.id
  }
)

export const fetchUserLoggedTreeNodes = _.memoize(() => {
  return dispatch => new Promise((resolve, reject) => {

    dispatch(_fetchingUserTreeNodes())

    // [TODO] to get all descendants and parents recursively 
    let includes = 'parent.parent.parent.parent.parent.parent,childs.childs.childs.childs.childs'

    MydAPI.get(`/users/me/treenodes?include=${includes}&page[size]=0`).then(treeNodes => {
      let retTreeNodes = _.chain(treeNodes.data.data).reduce((red, treeNode) => {
        return [
          ...red,
          ...getParentTreeNode(treeNode, treeNodes.data.included)
        ]
      }, []).uniqBy('id').value()

      dispatch(_fetchedUserTreeNodes(retTreeNodes))
      resolve(retTreeNodes)

    }).catch(err => {
      reject(err)
    })
  })
})

export const fetchTreenodesAssociatedToEvaluation = _.memoize((evaluationId) => {
  return new Promise((resolve, reject) => {

    MydAPI.get(`/ict/plannings/evaluation/${evaluationId}/treenodes?page[size]=0&include=parent.parent.parent.parent.parent.parent`).then(treeNodes => {
      let retTreeNodes = _.map([
        ...treeNodes.data.data,
        ...treeNodes.data.included,
      ], treenode => {
        return {
          id: treenode.id,
          ...treenode.attributes,
        }
      })

      resolve(retTreeNodes)

    }).catch(err => {
      reject(err)
    })
  })
})
